import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledCalendar = styled.div(_templateObject(), function (props) {
  return "\n        position: relative;\n        box-sizing: border-box;\n        font-family: ".concat(props.theme.global.typographyConfig.body.fontFamily, ";\n        font-size: ").concat(props.theme.components.dateRange.fontSize, ";\n        line-height: ").concat(props.theme.components.dateRange.lineHeight, ";\n        font-weight: ").concat(props.theme.components.dateRange.fontWeight, ";\n        padding: 12px;\n        width: ").concat(props.width, ";\n        min-width: ").concat(props.width, ";\n        height: ").concat(props.height, ";\n        user-select: none;\n        flex: min-content;\n    ");
});